import * as actionTypes from './actionTypes';
import * as opportunityService from './service'
import {applyFilter} from "../../utils/general";

const log = require("loglevel").getLogger("OpportunityActions");
log.setLevel("error");

export const loadOpportunityById = (id, callback) => {
	return async (dispatch) => {
		log.debug("OpportunityActions -> loadOpportunityById -> Enter");

		const opportunity = await opportunityService.loadOpportunityById(id);

		await dispatch ({
			type: actionTypes.OPPORTUNITY_LOADED,
			data: opportunity
		});

		callback?.(opportunity);
	}
};

export const loadOpportunityPicklists = () => {
	return async (dispatch) => {
		log.debug("OpportunityActions -> loadOpportunityPicklists -> Enter");

		const picklists = await opportunityService.loadOpportunityPicklists();

		await dispatch ({
			type: actionTypes.OPPORTUNITY_PICKLISTS_LOADED,
			data: picklists
		});
	}
};

export const loadOpportunities = (selectedFilters, forceReload) => {
	return async (dispatch) => {
		log.debug("OpportunityActions -> loadOpportunities -> Enter");

		const result = await opportunityService.loadOpportunities(selectedFilters, forceReload);

		const records = result?.data?.records ?? [];
		const lastUpdated = result?.data?.lastUpdated;

		let filteredOpportunities = records;

		selectedFilters?.forEach(filter => {
			filteredOpportunities = applyFilter(filteredOpportunities, filter);
		});

		await dispatch ({
			type: actionTypes.OPPORTUNITIES_LOADED,
			data: filteredOpportunities,
			lastUpdated
		});
	}
};

export const saveOpportunity = (opportunityId, updatedFields,selectedVendor, callback) => {
	return async (dispatch) => {
		log.debug("OpportunityActions -> saveOpportunity -> Enter");

		const result = await opportunityService.saveOpportunity(opportunityId, updatedFields, selectedVendor);
		await dispatch(loadOpportunityById(opportunityId));
		callback?.(result);
	}
};

export const createOpportunity = (updatedFields, callback) => {
	return async (dispatch) => {
		log.debug("OpportunityActions -> createOpportunity -> Enter");

		const result = await opportunityService.createOpportunity(updatedFields);
		// await dispatch(loadOpportunityById(result.opportunityId));
		callback?.(result);
	}
};